<template>
  <Panel class="tab-section" v-show="isActive" :collapsible="false" :title="title" :subTitle="subTitle" :tag="tag">
    <div class="tabTitle">{{ tabTitle }}</div>
    <slot></slot>
  </Panel>
</template>

<script>
  export default {
    name: "TabSection",

    props: {
      title: String,
      tabTitle: String,
      subTitle: String,
      tag: String,
      condition: {
        type: Boolean,
        default: true
      },
    },

    data() {
      return {
        activeTab: null,
        uuid: generateUUID(),
      }
    },
    computed: {
      me() {
        return this;
      },
      isActive() {
        return this.$parent.activeTab === this;
      },
      key() {
        return this.title + "-" + this.uuid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tabTitle {
    display: none;
  }
  .tab-section {
    flex-grow: 1;
  }
</style>